import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { Toaster } from 'sonner';

import { CustomerPopover } from './components/CustomerPopover';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LanguagePopover } from './components/LanguagePopover';
import { AuthProvider } from './contexts/AuthContext';
import { queryClient } from './lib/queryClient';
import { Router } from './Router';

import i18n from '@/lib/i18n';

export function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Router />

            <CustomerPopover position="top-right" />
            <LanguagePopover position="top-right" />
          </AuthProvider>

          <Toaster position="bottom-center" />
          <ReactQueryDevtools />
        </QueryClientProvider>
      </ErrorBoundary>
    </I18nextProvider>
  );
}
